import React from "react";
import Customers from "../Customers";
import { indiaOperations } from "../../utils/indiaOperationsSource";

/** India "Customers" page: the Australian Customers page on India customers. */
const IndiaCustomers = () => <Customers source={indiaOperations} />;

export default IndiaCustomers;
